import SortableCell from 'components/shared/Helpers/SortableCell'
import config from 'config/config'
import React from 'react'
import { push } from 'react-router-redux'
import { Table } from 'semantic-ui-react'
import { connect } from 'react-redux'

const mapStateToProps = (state, ownProps) => {
  const { users = [] } = state.userAdmin
  return { users }
}

class CartBrowserRow extends React.PureComponent {
  render() {
    const { selected, kind, order, dispatch, users } = this.props
    if (users.length === 0) return false
    const user =
      users.find((user) =>
        order.data.original_user_id
          ? user.id === order.data.original_user_id
          : user.id === order.user_id
      ) || {}
    return (
      <Table.Row
        active={selected}
        onClick={(event) => {
          event.preventDefault()
          dispatch(push(config.nodes[kind.slice(0, -1)] + order.id))
        }}>
        <SortableCell
          width={2}
          name="finalized_at"
          textAlign="right"
          text={new Date(order.data.finalized_at).toLocaleDateString(
            'de-CH',
            config.format.date
          )}
        />
        <Table.Cell
          className="ellipsis"
          width={9}
          name="address1"
          content={
            user.address1 ||
            ((order.data || {}).billing_address || {}).address_1 ||
              ((order.data || {}).billing_address || {}).address_2

          }
        />
        <Table.Cell
          width={1}
          name="products"
          textAlign="right"
          content={((order.data || {}).products || []).reduce((acc, p) => acc + p.quantity, 0)}
        />
      </Table.Row>
    )
  }
}
export default connect(mapStateToProps)(CartBrowserRow)



// WEBPACK FOOTER //
// ./src/components/admin/Carts/CartBrowserRow.jsx